const getCountAndUnitTerms = (daysDifference, noOfChartPoints) => {
    const countTerm = daysDifference / (noOfChartPoints - 1);

    return countTerm;
};

const getShowPointsAndDayTerm = noOfChartPoints => {
    let labelCount = 6;
    if (noOfChartPoints < 5 && noOfChartPoints > 1) labelCount = noOfChartPoints;
    const interval = labelCount - 1;
    const pointsToDivide = noOfChartPoints - labelCount;
    let current = 0;
    let showPointsList = [];
    let term = 0;
    for (let i = 0; i < interval; i++) showPointsList.push(0);
    for (let i = 1; i * interval <= pointsToDivide; i++) term = i;
    showPointsList = showPointsList.map(() => term);
    let remaning = pointsToDivide - term * interval;
    for (let i = 0; i < showPointsList.length && remaning > 0; i++) {
        showPointsList[i] += 1;
        --remaning;
    }
    showPointsList = showPointsList.map(i => {
        const a = i + current + 1;
        current = a;

        return a;
    });
    showPointsList.unshift(0); // adding 1st label hardcoded

    return showPointsList;
};

const setNoOfChartPointsWithObjective = (daysDiff, yearDiff) => {
    let noOfChartPoints;

    if (yearDiff >= 10) {
        noOfChartPoints = 106;
    } else if (yearDiff >= 2 && yearDiff < 10) {
        noOfChartPoints = 66;
    } else if (yearDiff < 2 && daysDiff >= 55) {
        noOfChartPoints = 56;
    } else if (daysDiff >= 1 && daysDiff < 55) {
        noOfChartPoints = Math.round(daysDiff) + 1;
    } else {
        noOfChartPoints = 0;
    }

    return noOfChartPoints;
};

const setNoOfChartPointsWithoutObjective = chartYears => {
    let noOfChartPoints;

    switch (chartYears) {
        case 2:
            noOfChartPoints = 45;
            break;
        case 10:
            noOfChartPoints = 66;
            break;
        case 25:
            noOfChartPoints = 106;
            break;
        default:
            noOfChartPoints = 66;
    }

    return noOfChartPoints;
};

const setDifferenceAndChartPoints = goalDate => {
    const now = new Date().setHours(0, 0, 0, 0);
    const goalData = new Date(goalDate);

    const daysDiff = (goalData - now) / (1000 * 60 * 60 * 24);
    const yearDiff = parseFloat(((goalData - now) / (1000 * 60 * 60 * 24 * 365.25)).toFixed(2));
    const noOfChartPoints = setNoOfChartPointsWithObjective(daysDiff, yearDiff);

    return {
        daysDiff,
        yearDiff,
        noOfChartPoints,
    };
};

export default {
    getCountAndUnitTerms,
    getShowPointsAndDayTerm,
    setNoOfChartPointsWithObjective,
    setNoOfChartPointsWithoutObjective,
    setDifferenceAndChartPoints,
};
